<template>
  <div class="badges-wrap">
    <BadgeSdg :start="type" :isOverlay="isOverlay" />
    <BadgeCards :start="type" :isOverlay="isOverlay"  />
    <BadgeDishes :start="type" :isOverlay="isOverlay" />
    <BadgePyramid :start="type" :isOverlay="isOverlay" />
    <BadgeChat :start="type" :isOverlay="isOverlay" />

  </div>
</template>

<script>

import {gsap} from 'gsap'
import BadgeSdg from './BadgeSdg.vue'
import BadgeCards from './BadgeCards.vue'
import BadgeDishes from './BadgeDishes.vue'
import BadgePyramid from './BadgePyramid.vue'
import BadgeChat from './BadgeChat.vue'
export default {
  name: 'BadgesWrap',
  props: ['start', 'type', 'isOverlay', 'closeOverlayCards'],
  components:{
    BadgeSdg,
    BadgeCards,
    BadgeDishes,
    BadgePyramid,
    BadgeChat
  },
  data(){
    return {

    }
  },
  methods:{
    startTransition(){
      
      var TL = gsap.timeline()
      TL.to('.badges-wrap', {top: 0})
    }
  },
  mounted(){
    
  },
  computed:{
   
  },
  watch: {
    start(val){
      
      if(val !== '') this.startTransition()
    }
  }
}
</script>

<style lang="scss">
  .badges-wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 100%;
    left: 0;
    z-index: 8;
  }
</style>